import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';
import * as api from '../../services/api';
import LoadingSpinner from '../../components/LoadingSpinner';
import ErrorMessage from '../../components/ErrorMessage';
import ResearchItem from '../../components/ResearchItem';

/**
 * 通用的洞察分类页面组件
 * @param {string} category - 分类名称
 * @param {boolean} featured - 是否查询精选文章
 * @param {string} titleKey - 页面标题的翻译键
 * @param {string} subtitleKey - 页面副标题的翻译键
 * @param {string} categoryLabelKey - 分类标签的翻译键
 */
const CategoryInsights = ({ category, featured, titleKey, subtitleKey, categoryLabelKey }) => {
  const { t, i18n } = useTranslation();
  const [insights, setInsights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const breadcrumbs = [
    { labelKey: 'nav.insights', href: '/#insights' },
    { labelKey: categoryLabelKey }
  ];

  useEffect(() => {
    const fetchInsights = async () => {
      try {
        setLoading(true);
        // 构建查询参数
        const params = {};
        if (featured !== undefined) {
          params.featured = featured;
        } else if (category && category !== 'featured-insights') {
          params.category = category;
        }
        
        const data = await api.getInsights(params);
        setInsights(data);
        setError(null);
      } catch (err) {
        console.error(`Error fetching insights:`, err);
        setError('Failed to load insights');
      } finally {
        setLoading(false);
      }
    };

    fetchInsights();
  }, [category, featured]);

  const getCurrentLang = () => {
    return i18n.language === 'zh-CN' ? 'zh_CN' : 'en_US';
  };

  const lang = getCurrentLang();

  return (
    <PageTemplate 
      titleKey={titleKey}
      subtitleKey={subtitleKey}
      breadcrumbs={breadcrumbs}
    >
      {loading && <LoadingSpinner />}
      {error && <ErrorMessage message={error} />}
      
      {!loading && !error && (
        <div className="content-card">
          <div className="insights-list">
            {insights.map((insight) => (
              <ResearchItem
                key={insight._id || insight.slug}
                title={insight.title[lang]}
                summary={insight.summary[lang]}
                author={insight.author[lang]}
                date={insight.publish_date}
                readTime={insight.read_time}
                category={insight.category}
                image={insight.cover_image}
                slug={insight.slug}
              />
            ))}
          </div>

          {insights.length === 0 && (
            <p style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
              {t('pages.categoryInsights.noContent')}
            </p>
          )}
        </div>
      )}
    </PageTemplate>
  );
};

export default CategoryInsights;
